<template>

  <div class="container">

    <div class="handle-box-search">





      <el-row class="head-search">


        <el-col :span="24" style="margin-bottom: 10px;">
          <span class="title">起止时间:</span>

          <el-date-picker v-model="search_time" type="datetimerange" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange"
            style="width: 300px;">
          </el-date-picker>
        </el-col>



      </el-row>

      <el-button type="primary" icon="el-icon-search" @click="searchcheckCarCardLists">搜索</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

    </div>

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">


      <el-table-column prop="id" label="id">
      </el-table-column>

      <el-table-column prop="city.name" label="城市">
      </el-table-column>


      <el-table-column prop="phone" label="电话">
      </el-table-column>



      <el-table-column prop="time.YmdHis" label="详细时间">
      </el-table-column>

    </el-table>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>


  </div>

</template>

<script>
  var _this;
  export default {


    data() {
      return {


        search_time: '',

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          fixed_array: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;
    },

    methods: {




      timeChange(val) {
        if(val !== null){
        _this.search_data.fixed_array = JSON.stringify(['between'].concat(val));

        }else{
          _this.search_data.fixed_array = ''
        }

      },
      searchcheckCarCardLists() {


        _this.search_data.page = 1;
        _this.checkCarCardLists();

      },
      // 搜索司机日志列表
      checkCarCardLists() {
        _this.$post(
            "/statistics/checkCarCardLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {


            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.checkCarCardLists();

      },


      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-form-item.el-form-item--small {
    width: 100%;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
  }
</style>